exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map {\n  height: 300px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/leaflet-map/leaflet-map.component.css
// module id = ../../../../../src/app/leaflet-map/leaflet-map.component.css
// module chunks = 0